import * as z from "zod";

export const retryRyderWebhookSubscription = {
  name: "retryRyderWebhookSubscription" as const,
  input: z.object({}),
  output: z.object({}),
};
